export const ESTATISTICA_TITLE = 'Estatística';
export const PRIMEIRO_TITLE = 'Data de recebimento do primeiro Borderô: ';
export const ULTIMO_TITLE = 'Data de recebimento do último Borderô: ';
export const QUANTIDADE_TITLE = 'Quantidade de Borderôs enviados: ';
